import { Button, Stack, Typography } from "@mui/material";
import { format, startOfTomorrow } from "date-fns";

import SuccessIcon from "./success-icon.svg";

export interface Props {
  domain: string;
  frequencyDays: number | null;
  nextRun?: Date | null | undefined;
  onDone: () => void;
}

function getFrequencyDescription(frequencyDays: number | null) {
  if (frequencyDays === 7) return " and then weekly thereafter";
  if (frequencyDays === 30) return " and then monthly thereafter";
  if (frequencyDays === 90) return " and then quarterly thereafter";
  return "";
}

export default function Success({
  domain,
  frequencyDays,
  nextRun,
  onDone,
}: Props) {
  return (
    <>
      <Stack
        style={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: "6em",
        }}
      >
        <img src={SuccessIcon} width={175} alt="" />
        <h3 style={{ color: "#66996C" }}>{domain} enrolled</h3>
        <Typography
          align="center"
          sx={{
            color: "#66996C",
          }}
        >
          The next monitor run will be on <br />
          {format(nextRun || startOfTomorrow(), "MMMM d, yyyy")}
          {getFrequencyDescription(frequencyDays)}.
        </Typography>
      </Stack>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "end",
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            onDone();
          }}
        >
          Done
        </Button>
      </div>
    </>
  );
}
